/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

export function addClass(element: any, name: string) {
    if (element.nodeType === 1) {
        if (element.classList) {
            element.classList.add(name);
        } else {
            element.className = element.className ? element.className + ' ' + name : name;
        }

    }
};

export function hasClass(element: any, name: string) {
    let result;

    if (element.classList) {
        result = element.classList.contains(name);
    } else {
        result = element.className.split(' ').indexOf(name) >= 0;
    }

    return result;
};

export function getElement(element: any) {
    return element.get ? element.get(0) : element;
};

export function removeElement(element: any) {
    let node = getElement(element),
        parentNode = node && node.parentNode;
        if (parentNode) {
            parentNode.removeChild(node);
        }
};
